import { Input, ITranslateInputProps } from 'legacy/lut/library/inputs'
import { ValidateInput } from 'legacy/lut/library/validation'
import React, { useCallback } from 'react'

import {
  DropdownBase,
  IDropdownProps as IBaseDropdownProps,
} from 'core-components/library/dropdown'

export interface IDropdownProps extends IBaseDropdownProps {
  translation?: string
  withoutValue?: boolean
}

export const Dropdown = ({ translation, withoutValue, ...props }: IDropdownProps) => {
  const prepareConfig = useCallback(
    (config: ITranslateInputProps) => {
      config.translation = translation

      if (withoutValue) {
        config.value = ''
      }
    },
    [translation, withoutValue]
  )
  return (
    <DropdownBase
      {...props}
      prepareInputConfig={prepareConfig}
      ValidateInputComponent={ValidateInput}
      InputComponent={Input}
    />
  )
}
